// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { createSelector } from 'reselect';

export const attachmentInfoSelector = createSelector(
    (state): any => state,
    (res: { attachmentInfo: any }) => res.attachmentInfo
);
